import styled from 'styled-components';

// {@code flex-shrink: 0} so the surrounding {@code PanelBody} flex
// column doesn't squash this card when total content overflows — the
// sidebar scrolls as a whole instead (consistent with the other dock
// cards: agent log, run history, execution log).
export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  padding: 16px 14px;
  background: ${({ theme: { colors = {} } }) => colors.cardSurface ?? '#15151F'};
  border: 1px solid
    ${({ theme: { colors = {} } }) => colors.outlineVariant ?? '#25263A'};
  border-radius: 24px;
  flex-shrink: 0;
`;
